import { Params } from "@angular/router";
import { ExecSyncOptionsWithBufferEncoding } from "child_process";

export interface Breadcrumb {
    id: number;
    caption: string;
    path: string;
    pathParam: string;
    queryParams: Array<Param>;
  }

export class Param{
  key: string;
  value: string;
}
